module.exports = __webpack_public_path__ + "img/1.046999e3.png";